var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientSecret(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.15,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 5.53C16 2.748 13.783.49 11.048.49S6.095 2.747 6.095 5.53c0 3.736 3.048 3.575 3.048 6.98 0 1.928 1.535 3.49 3.429 3.49C14.465 16 16 14.438 16 12.51M2.566 0A9 9 0 0 0 0 6.306a9 9 0 0 0 2.566 6.307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.724 2.194c-2.231 2.271-2.231 5.953 0 8.225M13.333 5.53c0-1.284-1.023-2.326-2.285-2.326-1.263 0-2.286 1.042-2.286 2.327 0 1.843 1.524 1.681 1.524 3.102 0 .856.682 1.55 1.524 1.55.841 0 1.523-.694 1.523-1.55"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientSecret);
export default __webpack_public_path__ + "static/media/client-secret.4a19de80fddbc586a1401e3e2c835cd8.svg";
export { ForwardRef as ReactComponent };